import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Flag = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <defs>
      <path
        id="flag-a"
        d="M19.333 5.333H8v9.334h11.333L16.667 10l2.666-4.667zM5.667 4c-.55 0-1 .45-1 1v14c0 .55.45 1 1 1s1-.45 1-1V5c0-.55-.45-1-1-1z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="flag-b" fill="#fff">
        <use xlinkHref="#flag-a"></use>
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#flag-a"></use>
      <g fill={props.color || theme.palette.grey600} mask="url(#flag-b)">
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
